var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pb-0", attrs: { cols: "12" } },
            [_c("create-stock")],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pt-0", attrs: { cols: "12" } },
            [
              _c("table-stock", {
                attrs: { "stock-id": _vm.stockUnitStockId },
                on: {
                  edit: _vm.editStock,
                  "update:stockId": function($event) {
                    _vm.stockUnitStockId = $event
                  },
                  "update:stock-id": function($event) {
                    _vm.stockUnitStockId = $event
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "30vw", eager: "" },
          model: {
            value: _vm.editStockDialog,
            callback: function($$v) {
              _vm.editStockDialog = $$v
            },
            expression: "editStockDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "mb-2",
                  attrs: {
                    dense: "",
                    collapse: "",
                    color: "purple darken-3",
                    elevation: "0",
                    dark: ""
                  }
                },
                [_c("span", [_vm._v("Edit")])]
              ),
              _c(
                "v-container",
                [
                  _c("edit-stock", {
                    attrs: { "stock-data": _vm.stockEditData },
                    on: {
                      "close-dialog": function($event) {
                        _vm.editStockDialog = false
                      },
                      "update:stockData": function($event) {
                        _vm.stockEditData = $event
                      },
                      "update:stock-data": function($event) {
                        _vm.stockEditData = $event
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("stock-unit", {
        attrs: { "stock-id": _vm.stockUnitStockId },
        on: {
          "update:stockId": function($event) {
            _vm.stockUnitStockId = $event
          },
          "update:stock-id": function($event) {
            _vm.stockUnitStockId = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }